import React from 'react'
import styles from '../BlocksPage/index.module.sass'
import classNames from 'classnames'
import {
    getTimeFromTimestamp,
    processedStringFromApi,
    round,
    stringTruncateFromCenter,
    stringTruncateFromLeft,
} from '../../../utils'

import { Transaction } from '../../../app/models/generated'
import { NavLink } from 'react-router-dom'
import { Icon } from '../../ui/Icon'
import { TypeOfTransaction } from '../../ui/TypeOfTransaction'
import { Status } from '../../ui/Status'

interface wrapperTransaction {
    transaction: Transaction
}

export const TokenTransItem = (props: wrapperTransaction) => {
    const currentTransaction = props.transaction

    const addressTo = currentTransaction.to
        ? currentTransaction.to.hash
        : currentTransaction.created_contract?.hash
    return (
        <tr className={styles.tableRow}>
            <td className={styles.tdCell}>
                <div>
                    <NavLink
                        to={'/transaction/' + currentTransaction.hash}>
                        {stringTruncateFromLeft(currentTransaction.hash)}
                    </NavLink>
                </div>
            </td>
            <td className={styles.tdCell}>
                <div className={styles.typeAndStatus}>
                    <TypeOfTransaction theme={currentTransaction.tx_types[0]}>
                        {processedStringFromApi(currentTransaction.tx_types[0])}
                    </TypeOfTransaction>
                    {/* <Status theme={currentTransaction.status}></Status> */}
                </div>
            </td>
            {/* <td className={styles.tdCell}>
                {currentTransaction.method ? <p className={styles.method}>{currentTransaction.method}</p> : ''}
            </td> */}
            <td className={styles.tdCell}>
                <NavLink
                    to={'/block/' + currentTransaction.block}>
                    {currentTransaction.block}
                </NavLink>
            </td>
            <td className={styles.tdCell}>
                 <p>
                    {getTimeFromTimestamp(currentTransaction.timestamp)}
                </p>
            </td>
            <td className={styles.tdCell}>
                <div className={styles.addressGroup}>
                    <NavLink
                        to={'/address/' + currentTransaction.from?.hash}>
                        {stringTruncateFromCenter(
                            currentTransaction.from?.hash,
                            8
                        )}
                    </NavLink>
                </div>
            </td>
            <td className={styles.tdCellW}>
                <div className={styles.addressGroup}>
                    <NavLink to={'/address/' + addressTo}>
                        {stringTruncateFromCenter(addressTo, 8)}
                    </NavLink>
                </div>
            </td>
            <td className={styles.tdCellRight}>
                {currentTransaction.value === '0'
                    ? 0
                    : round(
                          Number(currentTransaction.fee?.value) / 10 ** 18,
                          5
                      )} ETH
            </td>
        </tr>
    )
}
